/**
 * @generated SignedSource<<536574dac5aab4c07e08f3e13f0174d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AHTeamIconCircle$data = {
  readonly color: string | null;
  readonly isPrivate: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
  readonly " $fragmentType": "AHTeamIconCircle";
};
export type AHTeamIconCircle$key = {
  readonly " $data"?: AHTeamIconCircle$data;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AHTeamIconCircle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIcon"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "cc76ae65d6195c8e2e61c598fe2d10f0";

export default node;
